import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./Components/Login/LoginPage";
import DashboardLayout from "./Components/Layout/DashboardLayout";
import Home from "./Components/Dashboard/Home";
import Report from "./Components/Dashboard/Report";
import AllTickets from "./Components/Tickets/AllTickets";
import NewTickets from "./Components/Tickets/NewTickets";
import ApprovedTickets from "./Components/Tickets/ApprovedTickets";
import RejectedTickets from "./Components/Tickets/RejectedTickets";
import AssignedTickets from "./Components/Tickets/AssignedTickets";
import InProgressTickets from "./Components/Tickets/InProgressTickets";
import ReadyForReviewTickets from "./Components/Tickets/ReadyForReviewTickets";
import ReviewInProgressTickets from "./Components/Tickets/ReviewInProgressTickets";
import ReviewedTickets from "./Components/Tickets/ReviewedTickets";
import HoldTickets from "./Components/Tickets/HoldTickets";
import ClosedTickets from "./Components/Tickets/ClosedTickets";
import ReopenTickets from "./Components/Tickets/ReopenTickets";
import AssignToReviewerTickets from "./Components/Tickets/AssignToReviewerTickets";
import AdminLogin from "./Components/Admin-Orbit/Components/AdminLogin/AdminLogin";
import AdminDashboardLayout from "./Components/Admin-Orbit/Components/AdminLayout/AdminDashboardLayout/AdminDashboardLayout";
import AdminHome from "./Components/Admin-Orbit/Components/AdminDashboard/AdminHome";
import AdminReport from "./Components/Admin-Orbit/Components/AdminDashboard/AdminReport";
import AdminAIReport from "./Components/Admin-Orbit/Components/AdminDashboard/AdminAIReport";
import AdminDailyTaskAIReport from "./Components/Admin-Orbit/Components/AdminDashboard/AdminDailyTaskAIReport";
import AdminAllProjects from "./Components/Admin-Orbit/Components/AdminProjects/AdminAllProjects";
import AdminAddDeveloper from "./Components/Admin-Orbit/Components/AdminProjects/AdminAddDeveloper";
import AllTask from "./Components/Task/AllTasks";
import AssignedTask from "./Components/Task/AssignedTask";
import InProgressTask from "./Components/Task/InProgressTask";
import CompletedTask from "./Components/Task/CompletedTask";
import HoldTask from "./Components/Task/HoldTask";
import ReopenTask from "./Components/Task/ReopenTask";
import ClosedTask from "./Components/Task/ClosedTask";
import PublicRoute from "./Components/PublicRoute";
import ProtectedRoute from "./Components/ProtectedRoute";
import AllCreatedTask from "./Components/Task/CreatedTask/AllCreatedTask";
import CreatedAssignedTask from "./Components/Task/CreatedTask/CreatedAssignedTask";
import CreatedInProgressTask from "./Components/Task/CreatedTask/CreatedInProgressTask";
import CreatedCompletedTask from "./Components/Task/CreatedTask/CreatedCompletedTask";
import CreatedReopenTask from "./Components/Task/CreatedTask/CreatedReopenTask";
import CreatedHoldTask from "./Components/Task/CreatedTask/CreatedHoldTask";
import CreatedClosedTask from "./Components/Task/CreatedTask/CreatedClosedTask";
import AdminUserHistory from "./Components/Admin-Orbit/Components/AdminDashboard/AdminUserHistory";
import AdminProtectedRoute from "./Components/Admin-Orbit/Components/AdminProtectedRoute";
import ErrorFallback from "./Components/ErrorBoundary/ErrorFallback";
import ReportIssue from "./Components/Report-Issues/ReportIssue";
import { ADTicketsRoutes } from "./Components/Admin-Orbit/Components/AdminTickets/Routes/ADTicketsRoutes";
import { ADTaskRoutes } from "./Components/Admin-Orbit/Components/AdminTasks/Routes/ADTaskRoutes";
import MyProjects from "./Components/Dashboard/MyProjects";
import ReviewTicket from "./Components/Report-Issues/ReviewTicket";
// import TicketHistory from "./Components/Tickets/TicketHistory";
import ManageUsers from "./Components/Admin-Orbit/Components/UserManagement/Pages/ManageUsers"
import ClientAllTask from "./Components/Clients/pages/ClientTickets";
import ClientAllTickets from "./Components/Clients/pages/ClientTickets";
import TaskAssistant from "./Components/Admin-Orbit/Components/TaskAssistant/Pages/TaskAssistant";

const App = () => {
 useEffect(() => {
    const html = document.documentElement;

    const syncDarkMode = () => {
      const isDark = html.getAttribute("data-theme") === "dark";

      html.classList.toggle("dark", isDark);
    };

    syncDarkMode();
    const observer = new MutationObserver(syncDarkMode);

    observer.observe(html, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);


  return (
    <div className="relative">
      <Routes>
        {/* Login page (separate from dashboard layout) */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        {/* Admin Login Page */}
        <Route
          path="/Admin-Login"
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          }
        />

        {/* Dashboard layout with nested routes */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Home />} />
        </Route>
        <Route
          path="/Report"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Report />} />
        </Route>

        <Route
          path="/my-projects"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<MyProjects />} />
        </Route>

        <Route path="/All-Tickets" element={<DashboardLayout />}>
          <Route index element={<AllTickets />} />
        </Route>
        <Route path="/New-Tickets" element={<DashboardLayout />}>
          <Route index element={<NewTickets />} />
        </Route>
        <Route path="/Unassigned-Tickets" element={<DashboardLayout />}>
          <Route index element={<ApprovedTickets />} />
        </Route>
        <Route path="/Rejected-Tickets" element={<DashboardLayout />}>
          <Route index element={<RejectedTickets />} />
        </Route>
        <Route path="/Assigned-Tickets" element={<DashboardLayout />}>
          <Route index element={<AssignedTickets />} />
        </Route>
        <Route path="/In-Progess-Tickets" element={<DashboardLayout />}>
          <Route index element={<InProgressTickets />} />
        </Route>
        <Route path="/Ready-For-Review-Tickets" element={<DashboardLayout />}>
          <Route index element={<ReadyForReviewTickets />} />
        </Route>
        <Route path="/Assign-To-Reviewer-Tickets" element={<DashboardLayout />}>
          <Route index element={<AssignToReviewerTickets />} />
        </Route>
        <Route path="/Review-In-Progress-Tickets" element={<DashboardLayout />}>
          <Route index element={<ReviewInProgressTickets />} />
        </Route>
        <Route path="/Reviewed-Tickets" element={<DashboardLayout />}>
          <Route index element={<ReviewedTickets />} />
        </Route>
        <Route path="/Hold-Tickets" element={<DashboardLayout />}>
          <Route index element={<HoldTickets />} />
        </Route>
        <Route path="/Closed-Tickets" element={<DashboardLayout />}>
          <Route index element={<ClosedTickets />} />
        </Route>
        <Route path="/Reopen-Tickets" element={<DashboardLayout />}>
          <Route index element={<ReopenTickets />} />
        </Route>

        {/* Tasks */}
        <Route path="/Task/All-Tasks" element={<DashboardLayout />}>
          <Route index element={<AllTask />} />
        </Route>
        <Route path="/Task/Assigned-Task" element={<DashboardLayout />}>
          <Route index element={<AssignedTask />} />
        </Route>
        <Route path="/Task/In-Progress-Task" element={<DashboardLayout />}>
          <Route index element={<InProgressTask />} />
        </Route>
        <Route path="/Task/Completed-Task" element={<DashboardLayout />}>
          <Route index element={<CompletedTask />} />
        </Route>
        <Route path="/Task/Hold-Task" element={<DashboardLayout />}>
          <Route index element={<HoldTask />} />
        </Route>
        <Route path="/Task/Closed-Task" element={<DashboardLayout />}>
          <Route index element={<ClosedTask />} />
        </Route>
        <Route path="/Task/Reopen-Task" element={<DashboardLayout />}>
          <Route index element={<ReopenTask />} />
        </Route>

        {/* <Route path="/Tickets-History/:ticketNumber" element={<DashboardLayout />}>
          <Route index element={<TicketHistory/>} />
        </Route> */}
        {/* Created Task Routes */}
        <Route
          path="/Created-Task/All-Created-Task"
          element={<DashboardLayout />}
        >
          <Route index element={<AllCreatedTask />} />
        </Route>
        <Route path="/Created-Task/Assigned-Task" element={<DashboardLayout />}>
          <Route index element={<CreatedAssignedTask />} />
        </Route>
        <Route
          path="/Created-Task/In-Progress-Task"
          element={<DashboardLayout />}
        >
          <Route index element={<CreatedInProgressTask />} />
        </Route>
        <Route
          path="/Created-Task/Completed-Task"
          element={<DashboardLayout />}
        >
          <Route index element={<CreatedCompletedTask />} />
        </Route>
        <Route path="/Created-Task/Re-Open-Task" element={<DashboardLayout />}>
          <Route index element={<CreatedReopenTask />} />
        </Route>
        <Route path="/Created-Task/Hold-Task" element={<DashboardLayout />}>
          <Route index element={<CreatedHoldTask />} />
        </Route>
        <Route path="/Created-Task/Closed-Task" element={<DashboardLayout />}>
          <Route index element={<CreatedClosedTask />} />
        </Route>

        {/* Admin Routes */}
        <Route element={<AdminProtectedRoute />}>
          <Route path="/Admin-Home" element={<AdminDashboardLayout />}>
            <Route index element={<AdminHome />} />
          </Route>
          <Route path="/Admin-Report" element={<AdminDashboardLayout />}>
            <Route index element={<AdminReport />} />
          </Route>
          <Route
            path="/Admin-Report/AI-Report"
            element={<AdminDashboardLayout />}
          >
            <Route index element={<AdminAIReport />} />
          </Route>
          <Route
            path="/Admin-Report/DailyTask-AI-Report"
            element={<AdminDashboardLayout />}
          >
            <Route index element={<AdminDailyTaskAIReport />} />
          </Route>
          <Route path="/User-History" element={<AdminDashboardLayout />}>
            <Route index element={<AdminUserHistory />} />
          </Route>
          <Route path="/Admin-Project" element={<AdminDashboardLayout />}>
            <Route index element={<AdminAllProjects />} />
          </Route>
          <Route path="/task-assistant" element={<AdminDashboardLayout />}>
            <Route index element={<TaskAssistant />} />
          </Route>
          <Route
            path="/Admin-Project-Team/:projectUID"
            element={<AdminDashboardLayout />}
          >
            <Route index element={<AdminAddDeveloper />} />
          </Route>
          {ADTicketsRoutes}
          {ADTaskRoutes}

          <Route
            path="/Admin/User/Manage-Users"
            element={<AdminDashboardLayout />}
          >
            <Route index element={<ManageUsers />} />
          </Route>
        </Route>

        <Route path="*" element={<ErrorFallback />} />
        <Route path="/bad-request" element={<ErrorFallback />} />
        {/* <Route path="/Report-Issue/:projectUID" element={<ReportIssue />} /> */}
        <Route path="/Report-Issue/:projectUID" element={<ReportIssue />} />

				<Route path="/Review-Ticket/:ticketUID" element={<ReviewTicket />} />

				<Route path="/client/tickets" element={<ClientAllTickets />}/>
			</Routes>
		</div>
	);
};

export default App;
